var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.observeVisiblity(),
          expression: "observeVisiblity()",
        },
      ],
      class: `product-item product-card ${_vm.stockManagedClass}`,
    },
    [
      _vm.isVisible
        ? [
            _vm.hoverCardEnabled
              ? _c("CarouselProductHoverCard", { attrs: { item: _vm.item } })
              : _vm._e(),
            _vm._v(" "),
            _c("CarouselProductImage", { attrs: { item: _vm.item } }),
            _vm._v(" "),
            _c("CarouselProductContent", {
              attrs: { item: _vm.item, "pack-pricing-enabled": true },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }